module.exports = __webpack_public_path__ + "static/media/link.d04c6b12.svg";